import { render } from "./TrainObjectsScreen.vue?vue&type=template&id=ed518c9a"
import script from "./TrainObjectsScreen.vue?vue&type=script&lang=js"
export * from "./TrainObjectsScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__